import { CardModel, PileCardModel } from "../../interface/game";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function pileAllFaceUpDragPolicy(): PileAnnotationPolicy {
    return (pile: PileCardModel[], cards: {[key: string]: CardModel}): PileCardModel[] => 
        pile.map((pileCard) => ({
            ...pileCard,
            draggable: cards[pileCard.id].faceUp
        }));
}